
import Vue from "vue";
import { mapState } from "vuex";
import { LOYALTY_ROUTE_NAMES } from "@/loyalty-routes";
import { IRootState } from "@/store/types";
import { LOYALTY, emptyAccountOffer } from "@/store/loyalty";
import { cloneDeep } from "@/helpers/object";

export default Vue.extend({
  props: {
    id: {
      // Comes through as a number from the router
      // And a string if you hit the URL directly
      type: [Number, String],
      required: false
    }
  },
  methods: {
    onSelectCustomer() {
      // When selecting a customer set the intial values
      // to that of the segment offer for the customer
      const accountOffer = cloneDeep(this.accountOffer);
      accountOffer.earnRates = this.segmentOffer.earnRates;
      accountOffer.channels = this.segmentOffer.channels;
      accountOffer.level = this.segmentOffer.level;

      this.$store.dispatch(
        LOYALTY.NS(LOYALTY.ACTIONS.SET_ACCOUNT_OFFER),
        accountOffer
      );
    }
  },
  computed: {
    hasAccountNumber(): boolean {
      return this.id != null;
    },
    hasAccountOffer() {
      return this.accountOffer && this.accountOffer.accountNumber != null;
    },
    loyaltyAccountOffersListRoute() {
      return LOYALTY_ROUTE_NAMES.ACCOUNT_OFFERS;
    },
    customerName() {
      return this.accountOffer && this.accountOffer.customerName;
    },
    detailRouteName: () => LOYALTY_ROUTE_NAMES.SEGMENT_OFFER_DETAILS,
    ...mapState({
      isLoading: (state: IRootState) => state.loyalty.isLoading,
      accountOffer: (state: IRootState) => state.loyalty.accountOffer,
      segmentOffer: (state: IRootState) =>
        state.loyalty &&
        state.loyalty.accountOffer &&
        state.loyalty.accountOffer.segment &&
        state.loyalty.segmentOfferList.find(
          (v: any) => v.segment.value === state.loyalty.accountOffer.segment
        )
    })
  },
  beforeMount() {
    // Ref data needs to be loaded before the offer data
    this.$store.dispatch(
      LOYALTY.NS(LOYALTY.ACTIONS.LOAD_CHANNEL_REFERENCE_DATA)
    );

    this.$store.dispatch(
      LOYALTY.NS(LOYALTY.ACTIONS.LOAD_SEGMENT_REFERENCE_DATA)
    );
  },
  async mounted() {
    this.$store.dispatch(LOYALTY.NS(LOYALTY.ACTIONS.TOGGLE_IS_LOADING), true);

    this.$store.dispatch(
      LOYALTY.NS(LOYALTY.ACTIONS.SET_ACCOUNT_OFFER),
      emptyAccountOffer
    );

    if (this.id) {
      await this.$store.dispatch(
        LOYALTY.NS(LOYALTY.ACTIONS.LOAD_ACCOUNT_OFFER),
        this.id
      );
    } else {
      // Creating a new accountOffer, already set to emptyAccountOffer
      // Get the segment offer when creating a new account offer
      // so we can load the default segment values on selecting a customer
      await this.$store.dispatch(
        LOYALTY.NS(LOYALTY.ACTIONS.LOAD_SEGMENT_OFFER_LIST)
      );
    }

    this.$store.dispatch(LOYALTY.NS(LOYALTY.ACTIONS.TOGGLE_IS_LOADING), false);
  }
});
